import { makeAutoObservable } from 'mobx'
import * as Cesium from '@cesiumgs/cesium-analytics'
import type { BillboardCollection, Viewer } from '@cesiumgs/cesium-analytics'
import {
  getBusstonList, getExpresswayList, getFirefightingList, getHsptlList,
  // getLodgingIndustry,
  // getRestaurant,
  getPrkplaceList, getPubofficeList, getPuborderList, getRuralLodging,
  getRuralTourism,
  getSchlList,
  getTraditionalMarket,
  sendLodgingIndustry,
  sendRestaurant,
} from '@/service/layerService'

export class LayerList {
  constructor() {
    makeAutoObservable(this)
  }

  viewer: Viewer | null = null
  HospitalBillboards: BillboardCollection | null = null
  PharmacyBillboards: BillboardCollection | null = null
  ELCHBillboards: BillboardCollection | null = null
  MSULBillboards: BillboardCollection | null = null
  HSCLBillboards: BillboardCollection | null = null
  PuborderBillboards: BillboardCollection | null = null
  FirefightingBillboards: BillboardCollection | null = null
  PubofficeBillboards: BillboardCollection | null = null
  BusstonBillboards: BillboardCollection | null = null
  ExpresswayBillboards: BillboardCollection | null = null
  PrkplaceBillboards: BillboardCollection | null = null
  RuralToursimBillboards: BillboardCollection | null = null
  RuralLodgingBillboards: BillboardCollection | null = null
  TraditionalMarketBillboards: BillboardCollection | null = null
  LodgingIndustryBillboards: BillboardCollection | null = null
  RestaurantBillboards: BillboardCollection | null = null
  RetailBillboards: BillboardCollection | null = null
  TechnicalServiceBillboards: BillboardCollection | null = null
  BusinessServiceBillboards: BillboardCollection | null = null
  EducationServiceBillboards: BillboardCollection | null = null
  FiltrationServiceBillboards: BillboardCollection | null = null
  RepairServiceBillboards: BillboardCollection | null = null
  OtherFacilitiesBillboards: BillboardCollection | null = null
  init(viewer: Viewer) {
    if (viewer) {
      this.viewer = viewer
      this.HospitalBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.PharmacyBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.ELCHBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.MSULBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.HSCLBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.PuborderBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.FirefightingBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.PubofficeBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.BusstonBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.ExpresswayBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.PrkplaceBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.RuralToursimBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.RuralLodgingBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.TraditionalMarketBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.LodgingIndustryBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.RestaurantBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.RetailBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.TechnicalServiceBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.BusinessServiceBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.EducationServiceBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.FiltrationServiceBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.RepairServiceBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
      this.OtherFacilitiesBillboards = viewer.scene.primitives.add(new Cesium.BillboardCollection({ scene: viewer.scene }))
    }
  }

  async addLayerList(type: string, id?: string | null) {
    const extend: any = this.viewer?.camera.computeViewRectangle()
    const neLng: any = Cesium.Math.toDegrees(extend.east)
    const neLat: any = Cesium.Math.toDegrees(extend.north)
    const seLng: any = Cesium.Math.toDegrees(extend.west)
    const seLat: any = Cesium.Math.toDegrees(extend.south)
    const params: object = {
      type,
      neLng,
      neLat,
      seLng,
      seLat,
    }
    const params2 = {
      idlFcltUnqNo: id,
    }

    const publicParam = () => {
      const options: any = {
        ServiceKey: window.SystemConfig.layerServiceKey,
        pageNo: 1,
        numOfRows: 1000,
        radius: 2000,
        cx: '',
        cy: '',
        indsLclsCd: '',
        type: 'json',
      }
      const extend: any = window.cviewer.camera.computeViewRectangle()
      const center = Cesium.Rectangle.center(extend)
      options.cx = Cesium.Math.toDegrees(center.longitude)
      options.cy = Cesium.Math.toDegrees(center.latitude)
      return { ...options }
    }
    switch (type) {
      case 'HOSPITAL':
        {
          const data: any = await getHsptlList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.HospitalBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around5.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'PHARMACY':
        {
          const data: any = await getHsptlList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.PharmacyBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around6.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'ELCH':
        {
          const data: any = await getSchlList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.ELCHBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around7.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'MSUL':
        {
          const data: any = await getSchlList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.MSULBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around8.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'HSCL':
        {
          const data: any = await getSchlList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.HSCLBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around9.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Puborder':
        {
          const data: any = await getPuborderList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.PuborderBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around10.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Firefighting':
        {
          const data: any = await getFirefightingList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.FirefightingBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around11.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Puboffice':
        {
          const data: any = await getPubofficeList(params)
          if (data.code === 200 && data.result.length > 0) {
          // eslint-disable-next-line array-callback-return
            data.result.map((item: any) => {
              this.PubofficeBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around12.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Busston':
        {
          const data: any = await getBusstonList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.BusstonBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around14.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Expressway':
        {
          const data: any = await getExpresswayList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.ExpresswayBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around15.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Prkplace':
        {
          const data: any = await getPrkplaceList(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.PrkplaceBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around16.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'RURAL_TOURISM':
        {
          const data: any = await getRuralTourism(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.RuralToursimBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around18.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'RURAL_LODGING':
        {
          const data: any = await getRuralLodging(params)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.RuralLodgingBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around17.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'LodgingIndustry':
        {
          const options = publicParam()
          options.indsLclsCd = 'I1'
          // const data: any = await getLodgingIndustry(options)
          const data: any = await sendLodgingIndustry(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.LodgingIndustryBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around50.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'Restaurant':
        {
          const options = publicParam()
          options.indsLclsCd = 'I2'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.RestaurantBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around19.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'TraditionalMarket':
        {
          const options = {
            neLng,
            neLat,
            seLng,
            seLat,
            apiKey: window.SystemConfig.facilityApiKey,
          }
          const data: any = await getTraditionalMarket(options)
          if (data.code === 200 && data.result.length > 0) {
            data.result.forEach((item: any) => {
              this.TraditionalMarketBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.x, item.y, 0),
                  image: './Symbol/icon-around20.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
        }
        break
      case 'Retail':
        {
          const options = publicParam()
          options.indsLclsCd = 'G2'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.RetailBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around22.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'TechnicalService':
        {
          const options = publicParam()
          options.indsLclsCd = 'M1'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.TechnicalServiceBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around23.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'BusinessService':
        {
          const options = publicParam()
          options.indsLclsCd = 'N1'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.BusinessServiceBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around24.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'EducationService':
        {
          const options = publicParam()
          options.indsLclsCd = 'P1'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.EducationServiceBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around25.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'FiltrationService':
        {
          const options = publicParam()
          options.indsLclsCd = 'R1'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.FiltrationServiceBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around26.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'RepairService':
        {
          const options = publicParam()
          options.indsLclsCd = 'S2'
          // const data: any = await getRestaurant(options)
          const data: any = await sendRestaurant(options)
          if (data.body.items.length === 0)
            return
          data.body.items.forEach((item: any) => {
            this.RepairServiceBillboards?.add(
              {
                position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                image: './Symbol/icon-around27.png',
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                id: item,
              },
            )
          })
        }
        break
      case 'OtherFacilities':
        {
          const fn = async () => {
            const options = publicParam()
            options.indsLclsCd = 'Q1'
            // const data: any = await getRestaurant(options)
            const data: any = await sendRestaurant(options)
            if (data.body.items.length === 0)
              return
            data.body.items.forEach((item: any) => {
              this.OtherFacilitiesBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                  image: './Symbol/icon-around28.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
          const fn2 = async () => {
            const options = publicParam()
            options.indsLclsCd = 'L1'
            // const data: any = await getRestaurant(options)
            const data: any = await sendRestaurant(options)
            if (data.body.items.length === 0)
              return
            data.body.items.forEach((item: any) => {
              this.OtherFacilitiesBillboards?.add(
                {
                  position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 0),
                  image: './Symbol/icon-around28.png',
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  id: item,
                },
              )
            })
          }
          fn()
          fn2()
        }
        break
    }
  }

  removeLayerList(type: string) {
    switch (type) {
      case 'HOSPITAL':
        this.HospitalBillboards?.removeAll()
        break
      case 'PHARMACY':
        this.PharmacyBillboards?.removeAll()
        break
      case 'ELCH':
        this.ELCHBillboards?.removeAll()
        break
      case 'MSUL':
        this.MSULBillboards?.removeAll()
        break
      case 'HSCL':
        this.HSCLBillboards?.removeAll()
        break
      case 'Puborder':
        this.PuborderBillboards?.removeAll()
        break
      case 'Firefighting':
        this.FirefightingBillboards?.removeAll()
        break
      case 'Puboffice':
        this.PubofficeBillboards?.removeAll()
        break
      case 'Busston':
        this.BusstonBillboards?.removeAll()
        break
      case 'Expressway':
        this.ExpresswayBillboards?.removeAll()
        break
      case 'Prkplace':
        this.PrkplaceBillboards?.removeAll()
        break
      case 'RURAL_TOURISM':
        this.RuralToursimBillboards?.removeAll()
        break
      case 'RURAL_LODGING':
        this.RuralLodgingBillboards?.removeAll()
        break
      case 'LodgingIndustry':
        this.LodgingIndustryBillboards?.removeAll()
        break
      case 'Restaurant':
        this.RestaurantBillboards?.removeAll()
        break
      case 'TraditionalMarket':
        this.TraditionalMarketBillboards?.removeAll()
        break
      case 'Retail':
        this.RetailBillboards?.removeAll()
        break
      case 'TechnicalService':
        this.TechnicalServiceBillboards?.removeAll()
        break
      case 'BusinessService':
        this.BusinessServiceBillboards?.removeAll()
        break
      case 'EducationService':
        this.EducationServiceBillboards?.removeAll()
        break
      case 'FiltrationService':
        this.FiltrationServiceBillboards?.removeAll()
        break
      case 'RepairService':
        this.RepairServiceBillboards?.removeAll()
        break
      case 'OtherFacilities':
        this.OtherFacilitiesBillboards?.removeAll()
        break
    }
  }
}
